import { motion, AnimatePresence } from 'framer-motion';

import { Modal, Props as ModalProps } from '@/components/Modal';
import { useEffect } from 'react';

type Props = ModalProps & { isOpen: boolean; onClose: () => void };

const stopPropagation = (e: React.MouseEvent<any>) => {
  e.stopPropagation();
};

export const OverlayModal: React.FC<Props> = ({
  isOpen,
  onClose,
  ...props
}) => {
  useEffect(() => {
    const onKeyDown = ({ key }: KeyboardEvent) => {
      if (isOpen && key === 'Escape') {
        onClose();
      }
    };
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [onClose, isOpen]);

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <div
            onClick={onClose}
            className="fixed flex flex-col items-center justify-center w-screen h-screen top-0 right-0 bottom-0 left-0 bg-gray-1200 bg-opacity-60 backdrop-blur-sm z-20"
          >
            <Modal onClick={stopPropagation} {...props} />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
